import Button from "../ui/Button/Button.jsx";
import { Link } from "react-router-dom";
import { useRef } from "react";
import TheTouchingHands from "../../Assets/Images/onehandgifting.jpg";
import { motion } from "framer-motion";
import { FadeIn, StaggerContainer } from "../ui/Motion";
import { STAGGER_VARIANTS } from "../../constants/animations";
import { useTranslation } from "react-i18next";

export default function FirstSection({ finalSectionRef }) {
  const { t } = useTranslation();
  const scrollToFinalSection = () => {
    if (finalSectionRef.current) {
      finalSectionRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section className="w-full py-12 md:py-24 lg:py-32 xl:py-72 relative overflow-hidden">
      <div className="absolute inset-0 opacity-10 flex justify-end items-center">
        <img
          src={TheTouchingHands}
          className="w-full h-full object-cover transform rotate-180"
          alt="The Gifting Lady"
        />
      </div>
      <div className="container px-4 md:px-6 relative">
        <div className="flex flex-col items-center space-y-4 text-center">
          <FadeIn className="space-y-2">
            <StaggerContainer
              as="h1"
              staggerDelay={0.3}
              delayChildren={0.3}
              className="font-open-sans text-3xl font-bold tracking-tighter sm:text-4xl md:text-5xl lg:text-6xl/none bg-clip-text text-transparent bg-gradient-to-tl from-red-600 via-orange-600 to-red-600"
            >
              {t("about.aboutHeroTitle")
                .split(" ")
                .map((word, index) => (
                  <motion.span key={index} variants={STAGGER_VARIANTS.item}>
                    {word}{" "}
                  </motion.span>
                ))}
            </StaggerContainer>
            <FadeIn
              as="p"
              delay={2.1}
              className="mx-auto max-w-[700px] text-gray-700 md:text-xl dark:text-neutral-green-400"
            >
              {t("about.aboutHeroDesc")}
            </FadeIn>
          </FadeIn>
          <div className="space-x-4">
            <Link to="/search">
              <Button variant="gradient" size="long" rounded="3xl">
                {t("homepage.sections.describe.buttonText")}
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
